function emitClickEvent(context, evt) {
  const listener = context.listeners['click'] || (() => {})

  return listener(context.props.items.expand)
}

function emitClickEditEvent(context, evt) {
  const listener = context.listeners['clickEdit'] || (() => {})

  return listener(context.props.items.data[0])
}

export default ({ props, listeners }) => {
  return (
    <tr>
      <td
        class="row-group-def text-primary"
        colspan={
          props.showGroupIcon ? props.columnLength - 1 : props.columnLength
        }
      >
        <a
          href="#"
          vOn:click_prevent={evt => emitClickEvent({ listeners, props }, evt)}
          class="mr-3"
        >
          <i
            class={
              props.items.expand ? 'far fa-minus-square' : 'far fa-plus-square'
            }
          />
        </a>
        <span class="ts-font-extrabold ts-tracking-wider">{props.itemKey}</span>
      </td>
      <td class={!props.showGroupIcon ? 'ts-hidden' : 'ts-text-right'}>
        <a
          href="#"
          vOn:click_prevent={evt => emitClickEditEvent({ listeners, props }, evt)
          }
          class="ts-text-center text-info"
        >
          <i class={props.showGroupIcon ? props.groupIcon : ''} />
        </a>
      </td>
    </tr>
  )
}
